const STATUS_PEDIDO: Record<string, string> = {
  APPROVED: 'Aprovado',
  CANCELLED: 'Cancelado',
  UNPAID: 'Não pago',
  PENDING: 'Pendente',
  WAITING_PAYMENT: 'Aguardando pagamento',
  REFUNDED: 'Reembolsado',
  DECLINED: 'Recusado',
  DESCONHECIDO: 'Desconhecido',
}

const MEIO_PAGAMENTO: Record<string, string> = {
  CREDIT_CARD: 'Cartão de crédito',
  DEBIT_CARD: 'Cartão de débito',
  PIX: 'Pix',
  BOLETO: 'Boleto',
  BANK_SLIP: 'Boleto',
  FREE: 'Gratuito',
  PAYPAL: 'PayPal',
  PICPAY: 'PicPay',
}

const CATEGORIA_VIP: Record<string, string> = {
  membro: 'Membro',
  infinity: 'Infinity',
  socio: 'Sócio',
  socio_elite: 'Sócio Elite',
  disruption: 'Disruption',
  anuidade: 'Anuidade',
  acompanhante: 'Acompanhante',
}

/** Valor cru fora do mapa: 'SOME_NEW_VALUE' → 'Some new value'. */
function humaniza(bruto: string): string {
  const texto = bruto.replace(/_/g, ' ').toLowerCase().trim()
  return texto === '' ? bruto : texto.charAt(0).toUpperCase() + texto.slice(1)
}

export function rotuloStatusPedido(status: string): string {
  return STATUS_PEDIDO[status.toUpperCase()] ?? humaniza(status)
}

export function rotuloCategoriaVip(categoria: string): string {
  return CATEGORIA_VIP[categoria.toLowerCase()] ?? humaniza(categoria)
}

export function rotuloMeioPagamento(meio: string): string {
  // '—' é o balde de "sem meio informado" do backend — passa intacto.
  if (meio === '—') return meio
  return MEIO_PAGAMENTO[meio.toUpperCase()] ?? humaniza(meio)
}
